var map = {
	"./hm1.PNG": 33,
	"./hm10.PNG": 34,
	"./hm2.PNG": 35,
	"./hm3.PNG": 36,
	"./hm4.PNG": 37,
	"./hm5.PNG": 38,
	"./hm6.PNG": 39,
	"./hm7.PNG": 40,
	"./hm8.PNG": 41,
	"./hm9.PNG": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;